import { SvgIcon } from '@mui/material';
import React from 'react';

/**
 * Logo Bol.com (marketplace) – logo officiel avec couleur bleue caractéristique.
 * Source : Logo of Bol (2025).svg (couleur officielle #0000a4).
 */
const BolIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 153.14639 60.01226" {...props}>
      <g transform="translate(-36.777084,-146.31458)">
        <path
          fillRule="nonzero"
          fill="#0000a4"
          fillOpacity="1"
          d="m 118.11421,158.91957 c 19.34368,0 26.73562,12.59208 26.73562,23.70578 0,12.15372 -8.50933,23.70149 -26.56371,23.70149 -19.339385,0 -26.90323,-12.50186 -26.90323,-23.70149 0,-11.80991 7.993616,-23.70578 26.73132,-23.70578 m 0,32.5632 c 5.4666,0 9.23133,-3.64868 9.23133,-8.85742 0,-5.20876 -3.76473,-8.85744 -9.23133,-8.85744 -5.4623,0 -9.22703,3.64868 -9.22703,8.85744 0,5.20874 3.76473,8.85742 9.22703,8.85742"
          strokeWidth="1.1002"
        />
        <path
          fillRule="nonzero"
          fill="#0000a4"
          fillOpacity="1"
          d="m 148.39968,146.31458 h 17.48709 v 59.21718 h -17.48709 z m 0,0"
          strokeWidth="1.1002"
        />
        <path
          fillRule="nonzero"
          fill="#0000a4"
          fillOpacity="1"
          d="m 189.92347,195.6601 c 0,-5.89207 -4.77468,-10.66677 -10.66675,-10.66677 -5.89205,0 -10.66674,4.7747 -10.66674,10.66677 0,5.89203 4.77469,10.66674 10.66674,10.66674 5.89207,0 10.66675,-4.77471 10.66675,-10.66674"
          strokeWidth="1.1002"
        />
        <path
          fillRule="nonzero"
          fill="#0000a4"
          fillOpacity="1"
          d="m 36.777084,146.31458 h 17.487095 v 14.50023 c 3.438113,-1.30216 6.987958,-1.91242 10.683935,-1.91242 13.752447,0 23.722969,10.07366 23.722969,23.87765 0,10.4218 -7.134087,22.75172 -23.379158,22.75172 H 36.777084 Z m 17.487095,44.52356 c 2.346508,0.43836 4.959473,0.62745 6.700015,0.62745 6.351913,0 10.529225,-3.49827 10.529225,-8.85745 0,-5.2732 -4.091352,-8.85742 -10.004905,-8.85742 -2.174614,0 -4.787579,0.30096 -7.224335,1.0916 z m 0,0"
          strokeWidth="1.1002"
        />
      </g>
    </SvgIcon>
  );
};

export default BolIcon;